module.exports = __webpack_public_path__ + "static/media/logo_white.a36d5095.webp";